import React from "react"
import ScanQrCodeModal from "../../shared-components/ModulePopUp/ScanQrCodeModal"

const ScanQrCode = () => {
  return <ScanQrCodeModal />
}

export default ScanQrCode
